var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.pageLoading,
          expression: "pageLoading"
        }
      ],
      staticClass: "order_box"
    },
    [
      _c(
        "div",
        { staticClass: "page_title order_title" },
        [_c("custom-breadcrumb")],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "page_content flex" }, [
        _c("div", { staticClass: "order_nav flex" }, [
          _c(
            "div",
            { staticClass: "nav_msg flex" },
            [
              _c(
                "el-dropdown",
                {
                  attrs: { trigger: "click", placement: "bottom-start" },
                  on: { command: _vm.changeOrderTime }
                },
                [
                  _c("span", { staticClass: "el-dropdown-link" }, [
                    _vm.orderChangeTime == "All"
                      ? _c("span", [_vm._v(_vm._s(_vm.orderChangeTime))])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.orderChangeTime != "All"
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.orderChangeTime) + " days")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "el-icon-arrow-down el-icon--right"
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c("el-dropdown-item", { attrs: { command: "7" } }, [
                        _vm._v("Last 7 days")
                      ]),
                      _vm._v(" "),
                      _c("el-dropdown-item", { attrs: { command: "30" } }, [
                        _vm._v("Last 30 days")
                      ]),
                      _vm._v(" "),
                      _c("el-dropdown-item", { attrs: { command: "All" } }, [
                        _vm._v("All")
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "nav_msg flex" }, [
            _c("p", { staticClass: "nac_msg_name" }, [_vm._v("Orders")]),
            _vm._v(" "),
            _c("p", { staticClass: "nac_msg_num" }, [
              _vm._v(_vm._s(_vm.ordersCount.ordersCount))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nav_msg flex" }, [
            _c("p", { staticClass: "nac_msg_name" }, [_vm._v("Paid Order")]),
            _vm._v(" "),
            _c("p", { staticClass: "nac_msg_num" }, [
              _vm._v(_vm._s(_vm.ordersCount.paidOrdersCount))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nav_msg flex" }, [
            _c("p", { staticClass: "nac_msg_name" }, [_vm._v("Shipped Order")]),
            _vm._v(" "),
            _c("p", { staticClass: "nac_msg_num" }, [
              _vm._v(_vm._s(_vm.ordersCount.fulfilledOrderCount))
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-box" },
        [
          _c(
            "el-select",
            {
              attrs: { clearable: "", placeholder: "Order status" },
              on: {
                change: function($event) {
                  return _vm.changSelectHandel()
                }
              },
              model: {
                value: _vm.selectData.selectOrderStatus,
                callback: function($$v) {
                  _vm.$set(_vm.selectData, "selectOrderStatus", $$v)
                },
                expression: "selectData.selectOrderStatus"
              }
            },
            _vm._l(_vm.orderStatua, function(item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "el-select",
            {
              staticStyle: { "margin-left": "15px" },
              attrs: { clearable: "", placeholder: "Order Type" },
              on: {
                change: function($event) {
                  return _vm.changSelectHandel()
                }
              },
              model: {
                value: _vm.selectData.selectOrderType,
                callback: function($$v) {
                  _vm.$set(_vm.selectData, "selectOrderType", $$v)
                },
                expression: "selectData.selectOrderType"
              }
            },
            _vm._l(_vm.orderType, function(item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "date_text", staticStyle: { width: "180px" } },
            [_vm._v("Start Create Time")]
          ),
          _vm._v(" "),
          _c("el-date-picker", {
            staticStyle: { width: "200px" },
            attrs: {
              "value-format": "yyyy-MM-dd",
              type: "date",
              placeholder: "yyyy-mm-dd"
            },
            on: {
              change: function($event) {
                return _vm.changSelectHandel()
              }
            },
            model: {
              value: _vm.selectData.dateValue,
              callback: function($$v) {
                _vm.$set(_vm.selectData, "dateValue", $$v)
              },
              expression: "selectData.dateValue"
            }
          }),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "search_input",
            attrs: {
              "prefix-icon": "el-icon-search",
              placeholder:
                "Search orders by SKU,Product Name,Retailer Email,or order #",
              clearable: ""
            },
            model: {
              value: _vm.selectData.keyWords,
              callback: function($$v) {
                _vm.$set(_vm.selectData, "keyWords", $$v)
              },
              expression: "selectData.keyWords"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "search-btn",
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.changSelectHandel()
                }
              }
            },
            [_vm._v("Search\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page_table" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", height: "calc(100vh - 400px)" },
              attrs: {
                data: _vm.ordersData,
                height: "calc(100vh - 400px)",
                stripe: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "createdAt",
                  label: "Create Time/Order ID",
                  width: "250",
                  fixed: ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", { staticStyle: { color: "#707070" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.createdAt) +
                              "\n            "
                          ),
                          scope.row["type"] == "7"
                            ? _c(
                                "span",
                                {
                                  staticStyle: {
                                    background: "#F3E93D",
                                    padding: "0 5px"
                                  }
                                },
                                [_vm._v("ViLocal")]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(scope.row.orderId))])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "retailerName",
                  label: "Retailer",
                  width: "270",
                  fixed: ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.userSource == 1
                          ? _c("img", {
                              staticClass: "little_logo",
                              attrs: {
                                src:
                                  "https://shopvidi.oss-cn-beijing.aliyuncs.com/vidirect/v-logo.png",
                                alt: ""
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(scope.row.retailerName))]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(scope.row.remark))])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "orderStatus", label: "Status", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("statusDis")(scope.row.orderStatus))
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "date", label: "Action", width: "320" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.isShowShipped
                          ? _c(
                              "el-button",
                              {
                                staticClass: "action_button",
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.gotoShipped(scope.row)
                                  }
                                }
                              },
                              [_vm._v("\n            Shipped\n          ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        (scope.row.orderStatus == 0 ||
                          scope.row.orderStatus == 11) &&
                        (_vm.operate ||
                          (_vm.supplierManagementModelFlag &&
                            scope.row.brandShippingModel !== null &&
                            scope.row.brandShippingModel === 2))
                          ? _c(
                              "el-button",
                              {
                                staticClass: "action_button orange_background",
                                attrs: { type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.toCopyInfo(
                                      scope.row.retailerName,
                                      scope.row.orderId,
                                      scope.row.brandShippingModel
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n            Send Order Link\n          "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        (_vm.operate || _vm.supplierManagementModelFlag) &&
                        (scope.row.orderStatus == 40 ||
                          scope.row.orderStatus == 4)
                          ? [
                              scope.row.orderStatus == 40 &&
                              scope.row["type"] !== "6" &&
                              scope.row["type"] !== "1" &&
                              !scope.row["isRefuseFulfill"] &&
                              !scope.row["isProceedShipmented"] &&
                              (!scope.row["isMarkNonwares"] ||
                                (scope.row["isMarkNonwares"] &&
                                  scope.row["isNonwaresRetailerAgree"])) &&
                              !scope.row["isExistServiceOrder"]
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass:
                                        "action_button action_button2",
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$refs.outStackDialog.show(
                                            true,
                                            scope.row.orderId
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              Proceed the shipment\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row["isShowEditItem"]
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass:
                                        "action_button action_button2",
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$router.push({
                                            path: "edit-item-avaliability",
                                            query: {
                                              orderId: scope.row["orderId"],
                                              userSource:
                                                scope.row["userSource"]
                                            }
                                          })
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              Edit Item Availability\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.orderStatus == 40 &&
                              scope.row["type"] !== "6" &&
                              scope.row["type"] !== "1" &&
                              !scope.row["isRefuseFulfill"] &&
                              !scope.row["isProceedShipmented"] &&
                              !scope.row["isMarkNonwares"] &&
                              !scope.row["isExistServiceOrder"]
                                ? _c(
                                    "el-button",
                                    {
                                      staticClass:
                                        "action_button action_button2",
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.$refs.outStackDialog.show(
                                            false,
                                            scope.row.orderId
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n            Reject order\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.orderStatus == 40 &&
                              scope.row["isMarkNonwares"] &&
                              scope.row["isNonwaresRetailerAgree"] == null
                                ? _c("span", [
                                    _vm._v(
                                      "\n                There are out of stock items in the order, waiting for confirmation from the retailer\n            "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.orderStatus == 40 &&
                              scope.row["isMarkNonwares"] &&
                              scope.row["isNonwaresRetailerAgree"] != null &&
                                !scope.row["isNonwaresRetailerAgree"]
                                ? _c("span", [
                                    _vm._v(
                                      "\n              The retailer refuses to ship the remaining goods and has generated an after sale order\n            "
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.orderStatus == 40 &&
                              scope.row["isRefuseFulfill"]
                                ? _c("span", [
                                    _vm._v(
                                      "The order was rejected by the brand"
                                    )
                                  ])
                                : _vm._e()
                            ]
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.userInfo.id === _vm.superUserId
                ? _c("el-table-column", {
                    attrs: { label: "Order Review", width: "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return scope.row.orderStatus === 1 &&
                              !scope.row.isExistServiceOrder
                              ? [
                                  scope.row.type !== "7" ||
                                  (scope.row.type === "7" &&
                                    (scope.row.auditStatus === 2 ||
                                      (scope.row.auditStatus === 0 &&
                                        scope.row.brandReviewStatus === 0)))
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "text-decoration": "underline",
                                            cursor: "pointer"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.passOrder(
                                                scope.row.orderId
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              备货中\n          "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "text-decoration": "underline",
                                        cursor: "pointer",
                                        "margin-left": "10px"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.rejectOrder(
                                            scope.row.orderId
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              拒绝履约\n          "
                                      )
                                    ]
                                  )
                                ]
                              : undefined
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "payAmount",
                  label: "Order Details",
                  width: "120"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "text-decoration": "underline",
                              cursor: "pointer"
                            },
                            on: {
                              click: function($event) {
                                return _vm.toOrderDetail(scope.row)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  scope.row.orderStatus == "0" ||
                                    scope.row.orderStatus == "11"
                                    ? "Edit"
                                    : "View"
                                ) +
                                "\n          "
                            )
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.userInfo.id === _vm.superUserId ||
              _vm.userInfo.supplierManagementModel === 1 ||
              _vm.userInfo.supplierManagementModel === 2
                ? _c("el-table-column", {
                    attrs: { label: "Store Info", width: "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return scope.row.type === "7" &&
                              scope.row.auditStatus !== 0 &&
                              scope.row.brandReviewStatus === 2
                              ? [
                                  scope.row.auditStatus === 1
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "text-decoration": "underline",
                                            cursor: "pointer"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.gotoStoreInfo(
                                                scope.row.orderId,
                                                true
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              Store review\n          "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.auditStatus === 2
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "text-decoration": "underline",
                                            cursor: "pointer"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.gotoStoreInfo(
                                                scope.row.orderId,
                                                true
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              Store approved\n          "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.auditStatus === 3
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "text-decoration": "underline",
                                            cursor: "pointer"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.gotoStoreInfo(
                                                scope.row.orderId,
                                                true
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              Store rejected\n          "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              : undefined
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.userInfo.id === _vm.superUserId
                ? _c("el-table-column", {
                    attrs: { label: "运营审核", width: "150" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return scope.row.type === "7" &&
                              scope.row.brandReviewStatus !== 0
                              ? [
                                  scope.row.brandReviewStatus === 1
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "text-decoration": "underline",
                                            cursor: "pointer"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.gotoStoreInfo(
                                                scope.row.orderId,
                                                false
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              Store review\n          "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.brandReviewStatus === 2
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "text-decoration": "underline",
                                            cursor: "pointer"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.gotoStoreInfo(
                                                scope.row.orderId,
                                                false
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              Store approved\n          "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.brandReviewStatus === 3
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "text-decoration": "underline",
                                            cursor: "pointer"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.gotoStoreInfo(
                                                scope.row.orderId,
                                                false
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n              Store rejected\n          "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              : undefined
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "payAmount",
                  label: "Order Total",
                  width: "100"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(
                              scope.row.payAmount
                                ? Number(
                                    scope.row.payAmount
                                  ).toLocaleString("en-US", {
                                    style: "currency",
                                    currency: "USD"
                                  })
                                : "--"
                            )
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "brandName", label: "Brand", width: "" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "payTime", label: "Pay Time", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.orderStatus != 0 &&
                        scope.row.orderStatus != 2 &&
                        scope.row.orderStatus != 11
                          ? _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(scope.row.payTime) +
                                  "\n          "
                              )
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "shippingTime",
                  label: "Shipping Time",
                  width: "160"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.orderStatus == "3" ||
                        scope.row.orderStatus == "4" ||
                        scope.row.orderStatus == "5"
                          ? _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(scope.row.shippingTime) +
                                  "\n          "
                              )
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.supplierManagementModel !== 2
                ? _c("el-table-column", {
                    attrs: { label: "Invoice", width: "130" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm.operate ||
                              scope.row.userSource === 1 ||
                              _vm.supplierManagementModelFlag
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "invoice-view",
                                      on: {
                                        click: function($event) {
                                          return _vm.invoice(scope.row.orderId)
                                        }
                                      }
                                    },
                                    [_vm._v("\n            View\n          ")]
                                  )
                                : _c("span", [
                                    _vm._v("\n            -\n          ")
                                  ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      32055526
                    )
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Memo", width: "260" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.memo
                          ? _c(
                              "el-popover",
                              {
                                attrs: {
                                  placement: "top-start",
                                  width: "200",
                                  trigger: "hover",
                                  content: scope.row.memo
                                }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "memo",
                                    attrs: { slot: "reference" },
                                    slot: "reference"
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/img/none-memo.png"),
                                        alt: ""
                                      }
                                    })
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("Pagination", {
            attrs: {
              currentPage: _vm.selectData.pageNo,
              total: _vm.selectData.total,
              pageSize: _vm.selectData.pageSize
            },
            on: {
              handleSizeChange: _vm.handleSizeChange,
              handleCurrentChange: _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.acceptVisible, width: "30%" },
          on: {
            "update:visible": function($event) {
              _vm.acceptVisible = $event
            },
            close: function($event) {
              _vm.acceptVisible = false
            }
          }
        },
        [
          _c("span", { staticClass: "back_icon" }, [
            _c("i", { staticClass: "el-icon-arrow-left" }),
            _vm._v("Back")
          ]),
          _vm._v(" "),
          _vm.changeOrderNum == 40
            ? _c("p", { staticClass: "success_text" }, [
                _vm._v(
                  "\n      Please review the Item availability before shipping orders\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.changeOrderNum == 2
            ? _c("p", { staticClass: "success_text" }, [
                _vm._v(
                  "\n      Are you sure you want to cancel the order?\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.changeOrderNum == 5
            ? _c("p", { staticClass: "success_text" }, [
                _vm._v(
                  "\n      Please confirm that your order has been shipped\n    "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer flex_all",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.acceptVisible = false
                    }
                  }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.confirmOrderStatus()
                    }
                  }
                },
                [_vm._v("Confirm")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.copyVisible, width: "30%" },
          on: {
            "update:visible": function($event) {
              _vm.copyVisible = $event
            },
            close: function($event) {
              _vm.copyVisible = false
              _vm.copyEdit = false
            }
          }
        },
        [
          _c("span", { staticClass: "back_icon" }, [
            _c("i", { staticClass: "el-icon-arrow-left" }),
            _vm._v("Send Order Link")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "border_box" }, [
            _c("p", { staticClass: "copy_title" }, [_vm._v("Your Order Link")]),
            _vm._v(" "),
            _c("p", { staticClass: "copy_subtitle" }, [
              _vm._v(
                "\n        https://www.shopvidi.com/whosalesDetails/" +
                  _vm._s(_vm.rowOrderID) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _vm.brandShippingModel
              ? _c("p", { staticClass: "copy_title" }, [
                  _vm._v("ShopVidi Account")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.brandShippingModel
              ? _c("p", { staticClass: "copy_subtitle" }, [
                  _vm._v(_vm._s(_vm.nowretailerName))
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex_all" },
            [
              _c(
                "el-button",
                {
                  staticClass: "back_button",
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.copyLink($event)
                    }
                  }
                },
                [
                  _c("i", { staticClass: "el-icon-paperclip" }),
                  _vm._v(_vm._s(_vm.copyEdit ? "Copied" : "Copy") + "\n      ")
                ]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("out-stock-confirm-dialog", { ref: "outStackDialog" }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.reviewOrderDialogVisible,
            "show-close": false,
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              _vm.reviewOrderDialogVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "review-dialog-border" }, [
            _c(
              "div",
              { staticClass: "review-dialog-back", on: { click: _vm.back } },
              [_c("i", { staticClass: "el-icon-arrow-left" }), _vm._v("Back")]
            ),
            _vm._v(" "),
            _vm.reviewOrderType === 1
              ? _c("div", { staticClass: "review-dialog-pass" }, [
                  _c("div", { staticClass: "review-dialog-tips" }, [
                    _vm._v("确认要将订单审核通过改为备货中吗？")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "review-dialog-action" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        staticClass: "review-dialog-cancel",
                        on: { click: _vm.cancle }
                      },
                      [_vm._v("Cancel")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        staticClass: "review-dialog-confirm",
                        on: { click: _vm.confirm }
                      },
                      [_vm._v("Confirm")]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.reviewOrderType === 0
              ? _c("div", { staticClass: "review-dialog-reject" }, [
                  _c("div", { staticClass: "review-dialog-tips" }, [
                    _vm._v("确认要拒绝履约该订单吗？")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "review-dialog-action" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        staticClass: "review-dialog-cancel",
                        on: { click: _vm.cancle }
                      },
                      [_vm._v("Cancel")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ],
                        staticClass: "review-dialog-confirm",
                        on: { click: _vm.confirm }
                      },
                      [_vm._v("Confirm")]
                    )
                  ])
                ])
              : _vm._e()
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40ed3b7d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ed3b7d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/index.vue
// module id = 1eu4
// module chunks = 2